import { isDict } from 'ui-seeker/utils'

export const getOptionValues = options => isDict(options || {})
	? (options || {}).value || null
	: (options || []).map(op => op.value)

export const getOptionCurrency = options => isDict(options || {})
   ? (options || {}).currency || null
   : (options || []).map(op => op.currency)

export { default as useCommonFiltersParity } from './useCommonFiltersParity'
export { default as useCommonFiltersItems } from './useCommonFiltersItems'
export { default as useCommonFiltersAlerts } from './useCommonFiltersAlerts'
export { default as useCommonFilters } from './useCommonFilters'
export { default as useShareFilters } from './useShareFilters'
